import React from 'react';
import Avatar from 'react-avatar';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { removeAuthData } from '../../../store/actions/auth';
import { PROFILE_ROLE } from '../../../types';
import PowerIcon from './icons/power-icon.svg';
import './sidebar-footer.scss';
import UserProfilePicture from 'assets/images/user-profile-default.png';

interface SidebarFooterProps {
  sm?: boolean;
  accountName?: string;
  accountRole?: PROFILE_ROLE;
  companyName?: string;
  companyPhoto?: string;
}

const SidebarFooter: React.FC<SidebarFooterProps> = ({
  sm,
  accountName,
  companyName,
  accountRole,
  companyPhoto,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const roleMapping = () => {
    switch (accountRole) {
      case 'ADMIN':
        return 'Администратор';
      case 'VALIDATOR':
        return 'Валидатор';
      case 'VIEWER':
        return 'Наблюдатель';
      default:
        return '';
    }
  };

  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e && e.stopPropagation();
    dispatch(removeAuthData({}));
  };

  return (
    <>
      <ul className="sidebar__user-list">
        {companyName && (
          <li
            className="sidebar__user-item"
            onClick={() => history.push('/profile/company')}
          >
            <div className="sidebar-user">
              <Avatar
                size="32px"
                style={{ marginRight: '8px', minWidth: 32 }}
                round="8px"
                // size / textSizeRatio = textSize
                textSizeRatio={2.6}
                name={companyName.split('"')[1]}
                src={companyPhoto}
              />
              {!sm && (
                <div className="sidebar-user__body">
                  <div className="sidebar-user__name" title={companyName}>
                    {companyName}
                  </div>
                </div>
              )}
            </div>
          </li>
        )}
        {accountName && (
          <li
            className="sidebar__user-item"
            onClick={() => history.push('/profile/user')}
          >
            <div className="sidebar-user">
              <img
                className="sidebar-user__profile-picture"
                src={UserProfilePicture}
                alt={accountName}
              />
              {!sm && (
                <div className="sidebar-user__body">
                  <div className="sidebar-user__name" title={accountName}>
                    {accountName}
                  </div>
                  {accountRole && (
                    <div className="sidebar-user__desc">{roleMapping()}</div>
                  )}
                </div>
              )}
            </div>
          </li>
        )}
      </ul>
      <div className="sidebar__actions">
        <div className="sidebar-action" onClick={onClick}>
          <div className="sidebar-action__icon">
            <img src={PowerIcon} alt="Выйти" />
          </div>
          {!sm && <div className="sidebar-action__title">Закончить работу</div>}
        </div>
      </div>
    </>
  );
};

export default SidebarFooter;
